import React, { useCallback, useImperativeHandle, useState } from 'react'
import RoundedModal from '../../../../../molecules/RoundedModal'
import ModifyAccessTypeForm from './form'

const ModifyAccessTypeDialog = React.forwardRef(function ModifyAccessTypeDialog (_, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })
  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const complete = useCallback(async () => {
    close()
  }, [close])

  useImperativeHandle(ref, () => ({
    open: (user) => setDialogState({ open: true, processing: false, user })
  }), [setDialogState])

  return (
    <RoundedModal
      title='Modify User Access'
      open={dialogState.open}
      onClose={close}
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (<ModifyAccessTypeForm user={dialogState.user} onComplete={complete} onCancel={close} />) : null}
      </div>
    </RoundedModal>
  )
})

ModifyAccessTypeDialog.propTypes = {
}

export default ModifyAccessTypeDialog
